import React, { useState } from "react";
import { Button, Card, Input, message } from "antd";
import { Lock, Mail, ShieldCheck, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import reapi from "../../../api/reapi";

export default function AdminLogin() {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [form, setForm] = useState({
        email: "",
        password: "",
    });

    const handleLogin = async () => {
        try {
            if (!form.email || !form.password) {
                return message.error("Email and password required");
            }

            setLoading(true);

            // apni API yaha lagao
            const res = await reapi.post("/adm/login", form);

            console.log(res.data)

            localStorage.setItem("meeshoadminToken", res.data.token);

            message.success("Admin login successful");
            window.location.reload(``)

            navigate("/amd/ms");
        } catch (error) {
            message.error(
                error?.response?.data?.message || "Admin login failed"
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#f8f9ff] flex items-center justify-center p-4">
            <div className="w-full max-w-[1100px] grid grid-cols-1 lg:grid-cols-2 bg-white rounded-3xl shadow-xl overflow-hidden">
                <div className="hidden lg:flex bg-gradient-to-br from-[#061a4d] to-[#4f18d8] text-white p-12 flex-col justify-between">
                    <div>
                        <div className="flex items-center gap-4">
                            <div className="w-14 h-14 rounded-2xl bg-white/15 flex items-center justify-center">
                                <Sparkles size={34} />
                            </div>

                            <div>
                                <h1 className="text-3xl font-extrabold m-0">
                                    ShipLess AI
                                </h1>
                                <p className="text-purple-100 m-0">Admin Panel</p>
                            </div>
                        </div>

                        <h2 className="text-4xl font-extrabold mt-20 leading-tight">
                            Manage sellers, payments and optimizations from one place.
                        </h2>

                        <p className="text-purple-100 mt-5 text-lg">
                            Track users, credits, revenue and support requests easily.
                        </p>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <InfoBox title="Users" value="Manage" />
                        <InfoBox title="Payments" value="Track" />
                        <InfoBox title="Support" value="Resolve" />
                        <InfoBox title="Reports" value="Analyze" />
                    </div>
                </div>

                <div className="p-6 md:p-12 flex items-center">
                    <Card className="w-full border-0 shadow-none">
                        <div className="text-center mb-8">
                            <div className="w-20 h-20 rounded-3xl bg-purple-100 text-purple-600 flex items-center justify-center mx-auto">
                                <ShieldCheck size={42} />
                            </div>

                            <h1 className="text-3xl font-extrabold mt-5 mb-2">
                                Admin Login
                            </h1>

                            <p className="text-slate-500">
                                Enter your credentials to access admin dashboard
                            </p>
                        </div>

                        <div className="space-y-5">
                            <div>
                                <label className="font-bold block mb-2">Email Address</label>
                                <Input
                                    size="large"
                                    prefix={<Mail size={18} />}
                                    placeholder="admin@shipless.in"
                                    value={form.email}
                                    onChange={(e) =>
                                        setForm({ ...form, email: e.target.value })
                                    }
                                    className="rounded-xl h-12"
                                />
                            </div>

                            <div>
                                <label className="font-bold block mb-2">Password</label>
                                <Input.Password
                                    size="large"
                                    prefix={<Lock size={18} />}
                                    placeholder="Enter password"
                                    value={form.password}
                                    onChange={(e) =>
                                        setForm({ ...form, password: e.target.value })
                                    }
                                    className="rounded-xl h-12"
                                    onPressEnter={handleLogin}
                                />
                            </div>

                            <Button
                                type="primary"
                                block
                                size="large"
                                loading={loading}
                                onClick={handleLogin}
                                className="h-13 bg-purple-600 rounded-xl font-bold"
                            >
                                Login to Admin Panel
                            </Button>

                            <p className="text-center text-slate-500 text-sm">
                                🔒 Secure admin access only
                            </p>
                        </div>
                    </Card>
                </div>
            </div>
        </div>
    );
}

function InfoBox({ title, value }) {
    return (
        <div className="bg-white/10 rounded-2xl p-4">
            <p className="text-purple-100 m-0">{title}</p>
            <h3 className="text-xl font-bold m-0 mt-1">{value}</h3>
        </div>
    );
}